// iOS Safari ignores `maximum-scale=1` / `user-scalable=no` in the viewport meta
// (since iOS 10), so pinching on top of the map — the canvas but also its overlaid UI
// (controls, POI markers, toolbar...) — zooms the whole page instead of the map.
//
// These `gesture*` events are Safari-specific and unused by MapLibre (which relies on
// `touch*` events), so preventing them blocks the page zoom without breaking the map
// pinch-zoom. We scope the fix to the map wrapper (`.map-area`, present on every map
// page) so pinch-to-zoom stays available everywhere else (product images, articles...).

let initialized = false;

const preventMapAreaGesture = (event) => {
    if (event.target?.closest?.('.map-area')) {
        event.preventDefault();
    }
};

export default function initializePreventIosPageZoom() {
    if (initialized) {
        return;
    }
    initialized = true;

    document.addEventListener('gesturestart', preventMapAreaGesture, {passive: false});
    document.addEventListener('gesturechange', preventMapAreaGesture, {passive: false});
}